import { FormProvider } from 'react-hook-form';
import { Textarea, TextInput } from 'react-hook-form-mantine';
import { Button, Divider, FileInput, Flex, Text } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import {
	CREATE_DOCUMENT_TEMPLATE_FORM_FIELDS,
	useCreateDocumentTemplateForm,
} from '@dealstack/frontend/app/pages/DocumentTemplates/CreateDocumentTemplate/useCreateDocumentTemplateForm';
import { Wrapper } from './CreateDocumentTemplate.styled';

export const CreateDocumentTemplate = () => {
	const {
		navigate,
		createDocumentTemplateForm,
		onSubmit,
		isFormSubmitting,
		pdfFile,
		onSelectPdf,
		isDocxEnabled,
		uploadError,
	} = useCreateDocumentTemplateForm();
	const tDefault = useTranslationDefault();

	return (
		<Wrapper>
			<Button
				size="sm"
				variant="outline"
				onClick={() => navigate(ROUTES.TEMPLATES)}
				leftSection={<Icon variant="arrow-left" />}
			>
				Back to table
			</Button>
			<FormProvider {...createDocumentTemplateForm}>
				<Flex direction="column" gap="1rem" mt="1rem">
					<Flex gap="2rem" align="center" justify="space-between" mt="1rem">
						<Text size="B4Bold">Add new document template</Text>
						<Button
							size="md"
							variant="primary"
							onClick={createDocumentTemplateForm.handleSubmit(onSubmit)}
							disabled={isFormSubmitting}
						>
							Create
						</Button>
					</Flex>

					<Divider />

					<TextInput
						name={CREATE_DOCUMENT_TEMPLATE_FORM_FIELDS.NAME}
						control={createDocumentTemplateForm.control}
						label="Template name"
						placeholder="Enter template name"
						size="md"
						w="100%"
					/>
					<Textarea
						name={CREATE_DOCUMENT_TEMPLATE_FORM_FIELDS.DESCRIPTION}
						control={createDocumentTemplateForm.control}
						label="Description"
						placeholder="Enter template description"
						size="md"
						w="100%"
					/>

					<FileInput
						label={
							isDocxEnabled
								? tDefault('document_templates.create.file.label')
								: tDefault('document_templates.create.file.static_label')
						}
						description={tDefault('document_templates.create.file.static_description')}
						placeholder={
							isDocxEnabled
								? tDefault('document_templates.create.file.placeholder')
								: 'Choose a PDF'
						}
						accept={isDocxEnabled ? '.pdf,.docx' : 'application/pdf'}
						leftSection={<IconFileTypePdf size={16} />}
						value={pdfFile}
						onChange={(file) => void onSelectPdf(file)}
						required
						clearable
						size="md"
						w="100%"
						error={uploadError ?? undefined}
					/>
				</Flex>
			</FormProvider>
		</Wrapper>
	);
};
